import { throwError } from 'rxjs';

export const errorHandler = (err: any) => throwError(err.error || err);
